<template>
	<popup-layout>
		<template slot="page-content">
			<slot name="page-content">
				<create-token :showExpiration="false"></create-token>

				<div class="row">
					<button class="btn btn-secondary" type="button" @click="closeWindow()">Close Window</button>
				</div>
			</slot>
		</template>
	</popup-layout>
</template>

<script>
const router = require("@/router");

export default {
  methods: {
    closeWindow() {
      window.close();
    }
  }
};
</script>

<style scoped>
.row {
  margin-top: 20px;
  margin-left: 0;
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/AppCreateToken.vue